import { useState, useMemo, useLayoutEffect, useCallback } from 'react';

type Rect = {
  x: number;
  y: number;
  width: number;
  height: number;
  top: number;
  left: number;
  bottom: number;
  right: number;
};

let defaultRect: Rect = { x: 0, y: 0, width: 0, height: 0, top: 0, left: 0, bottom: 0, right: 0 };

export let useMeasure = (): [(element: Element | null) => void, Rect] => {
  let [element, setElement] = useState<Element | null>(null);
  let [rect, setRect] = useState<Rect>(defaultRect);

  let ref = useCallback((el: Element | null) => setElement(el), []);

  let observer = useMemo(() => {
    if (typeof window === 'undefined' || !window.ResizeObserver) return null;
    return new ResizeObserver(() => {
      if (element) {
        let r = element.getBoundingClientRect();
        setRect({ x: r.x, y: r.y, width: r.width, height: r.height, top: r.top, left: r.left, bottom: r.bottom, right: r.right });
      }
    });
  }, [element]);

  useLayoutEffect(() => {
    if (!element || !observer) return;
    let r = element.getBoundingClientRect();
    setRect({ x: r.x, y: r.y, width: r.width, height: r.height, top: r.top, left: r.left, bottom: r.bottom, right: r.right });
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, observer]);

  return [ref, rect];
};
